import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login/main';
import ClassicLogin from './pages/login/classicLogin';
import StudentAssignmentStart from './pages/login/components/StudentAssignmentStart';
import Main from './pages/assignments/pages/AssignmentsAndActivities/main';
import Classes from './pages/classes/pages/classRoute';
import MyContent from './pages/myContent/utils/myContentRoute';
import Reports from './pages/reports/utils/reportRoute';
import RequireAuth from './features/authentication/RequireAuth';
import PersistentLogin from './components/PersistentLogin';
import Dashboard from './pages/dashboard/main';
import MyProfile from './pages/myProfile/myProfile';
import ClassRoomView from './pages/assignments/pages/ManageAssign/components/ClassRoomView';
import Responses from './pages/assignments/pages/ManageAssign/components/Responses';
import QuestionsSearch from './pages/questionsSearch/main';
import ActivitiesSearch from './pages/activitySearch/main';
import ValidateSSO from './pages/login/validateSSO';
import ClassroomSSO from './pages/login/ClassroomSSO';
import SchoologySSO from './pages/login/SchoologySSO';
import CanvasSSO from './pages/login/CanvasSSO';
import MethodizeAuthenticateModel from './pages/methodize/pages';
import RookBlueprintAuthenticateModel from './pages/rookBlueprint/pages';
import { store } from './api/store';
import { logOut } from './features/authentication/authSlice';
import PublicRoute from './features/authentication/PublicRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';
import appConfig from './app-config';
import { RouteChangeWatcher } from './utils/RouteChangeWatcher';
import CustomCKFileBrowser from '../src/pages/ckEditor/components/CustomCKFileBrowser';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const googleClientId = appConfig.googleClientId;

window.addEventListener('storage', (event) => {
  if (event.key === 'logout') {
    store.dispatch(logOut());
    window.location.href = '/login';
  }
});

function App() {

  return (
    <div>
      <RouteChangeWatcher />
      <Routes>
        <Route element={<PersistentLogin />}>
          {/* Protected Routes */}
          <Route element={<RequireAuth />}>
            <Route element={<Navigate to="/dashboard" replace />} path="/" />
            <Route element={<Dashboard />} path="/dashboard/*" />
            <Route element={<Classes />} path="/classes/*" />
            <Route element={<Main />} path="/assignments/*" />
            <Route element={<MyContent />} path="/mycontent/*" />
            <Route element={<Reports />} path="/reports/*" />
            <Route element={<MyProfile />} path="/myProfile" />
            <Route element={<ClassRoomView />} path="/classroom_view/:id" />
            <Route element={<Responses />} path="/responses/:assignmentId/:activityType/:studentId/:sessionId?/:isSelfStudy?" />
            <Route element={<QuestionsSearch />} path="/questionsSearch/*" />
            <Route element={<ActivitiesSearch />} path="/activitiesSearch/*" />
            <Route element={<MethodizeAuthenticateModel />} path="/methodize/*" />
            <Route element={<RookBlueprintAuthenticateModel />} path="/rookBlueprint/*" />
          </Route>
          <Route element={<PublicRoute />}>
            <Route element={<Login />} path="/login/*" />
          </Route>
        </Route>

        {/* <Route element={<ClassicLogin />} path="/login" /> */}
        <Route element={<ClassicLogin />} path='/classicLogin/:session/:user/:lastAccess/:redirectPage/:logId/:sso/:signedInAsId?' />
        <Route element={<StudentAssignmentStart />} path='/StartAssignment/:url/:type?' />
        <Route element={<ValidateSSO />} path='/ValidateSSO' />
        <Route element={ <GoogleOAuthProvider clientId={googleClientId}><ClassroomSSO /></GoogleOAuthProvider>} path='/ClassroomSSO/*' />
        <Route element={<SchoologySSO />} path='/SchoologySSO/:url/:email' />
        <Route element={<CanvasSSO />} path='/CanvasSSO/:url/:email' />
        <Route path="/CustomCKFileBrowser" element={<CustomCKFileBrowser />} />        

        {/* Not found routes */}
        <Route element={<Navigate to="/login" />} path="*" />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
